import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedOTPRoute({ children }) {
  const location = useLocation();
  const signupData = location.state;

  useEffect(function () {
    // Store signup data in sessionStorage as backup
    if (signupData?.userName && signupData?.email && signupData?.password) {
      sessionStorage.setItem('otp-signup-data', JSON.stringify({
        userName: signupData.userName,
        email: signupData.email,
        password: signupData.password,
      }));
    }
  }, [signupData]);

  // Check if user came from signup (either via state or sessionStorage)
  const hasSignupData = signupData?.userName && signupData?.email && signupData?.password;
  const sessionSignupData = sessionStorage.getItem('otp-signup-data');

  if (!hasSignupData && !sessionSignupData) {
    // User didn't come from signup, redirect to signup page
    return <Navigate to="/signup" replace />;
  }

  return children;
}

export default ProtectedOTPRoute;
